<template lang="pug">
  div.app-riple
    div(:style="style")
    div(:style="style")
</template>

<script>
export default {
  name: 'AppLoader',
  props: {
    color: {
      type: String,
      default: '#c2c2c2'
    }
  },
  computed: {
    style () {
      return `border-color: ${this.color}`
    }
  }
}
</script>

<style lang="scss" scoped>
.app-riple {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.app-riple div {
  position: absolute;
  border-style: solid;
  border-width: 4px;
  opacity: 1;
  border-radius: 50%;
  animation: app-riple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.app-riple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes app-riple {
  0% {
    top: 28px;
    left: 28px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: -1px;
    left: -1px;
    width: 58px;
    height: 58px;
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppLoader.vue